module.exports = __webpack_public_path__ + "static/media/Instagram.30912465.svg";